import React from 'react';
import { oneOf, bool } from 'prop-types';
import cx from 'classnames';

import { Container, Grid, GridCol, ButtonToggle, Icon } from './../';

import Logo from '../Logo';
import LanguageSelector from '../../modules/LanguageSelector';
import Menu from '../../modules/Menu';
import SkipToContentButton from '../../modules/SkipToContentButton';
import Link from '../../modules/Link';

import HeaderStatic from './Header.static';

const propTypes = {
  /** Header style variants */
  variant: oneOf(['fixed']),
  /** Header dark style */
  dark: bool,
};

const CLASS_ROOT = 'header';

const getToggleData = toggle =>
  JSON.stringify([
    {
      target: '#icon-toggle-menu',
      attribute: 'icon',
      value: `/sprite.svg#${toggle ? 'menu-close' : 'menu-open'}`,
    },
    {
      target: '#page-navigation-mobile',
      attribute: 'class',
      value: 'hide',
    },
    {
      target: '#page-header',
      attribute: 'class',
      value: `${CLASS_ROOT}--with-nav`,
    },
    {
      target: 'body',
      effect: 'lock-body',
      value: toggle,
    },
  ]);

class Header extends React.Component {
  constructor(props) {
    super(props);

    this.instance = null;

    this.refHeader = React.createRef();
  }

  componentDidMount() {
    this.instance = new HeaderStatic(this.refHeader, {});
  }

  componentWillUnmount() {
    if (this.instance) this.instance.destroy();
  }

  render() {
    const { children, className, variant, dark, ...other } = this.props;

    const classes = cx(
      CLASS_ROOT,
      {
        [`${CLASS_ROOT}--${variant}`]: variant,
        [`${CLASS_ROOT}--dark`]: dark,
      },
      className
    );

    return (
      <div className={`${CLASS_ROOT}__wrapper`}>
        <SkipToContentButton />
        <header
          id="page-header"
          ref={c => {
            this.refHeader = c;
          }}
          role="banner"
          className={classes}
          {...other}
        >
          <Container>
            <Grid>
              <GridCol
                size={{ xs: 'fixed', l: 6 }}
                className="align-self-middle"
              >
                <Link className="mb-none" to="index">
                  <Logo
                    variant={dark ? 'dark' : 'light'}
                    width="38"
                    height="18"
                  />
                </Link>
              </GridCol>
              <GridCol
                className="d-flex align-items-middle pl-none"
                size="auto"
              >
                {children || <Menu className="show-l" />}
              </GridCol>
              {!children && (
                <GridCol
                  size="shrink"
                  className="align-self-right align-self-middle hide-l"
                >
                  <ButtonToggle
                    padded
                    className="mb-none"
                    data-toggle={getToggleData(true)}
                  >
                    <Icon
                      id="icon-toggle-menu"
                      name="menu-open"
                      size="medium"
                      data-toggle-icon-target
                    />
                  </ButtonToggle>
                </GridCol>
              )}
              <GridCol
                size="shrink"
                className={cx(
                  'd-flex text-nowrap align-self-right align-items-middle',
                  {
                    'show-l': !children,
                  }
                )}
              >
                <LanguageSelector />
              </GridCol>
            </Grid>
          </Container>
        </header>
        {!children && (
          <Menu id="page-navigation-mobile" isMobile className="hide" />
        )}
      </div>
    );
  }
}

Header.propTypes = propTypes;
Header.displayName = 'Header';

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js